import { useNotesModalContext } from '@/react/components/entityViews/notes/context/NotesModalContext';
import { useNotesMenu } from './useNotesMenu';
import { BoardNote } from '@/bryntum-lib/models/BoardNote';
import { EntityRecord } from '@/types/entity';

interface UseNotesModalParams {
  record: EntityRecord;
  noteRecord: BoardNote | null;
  isEditor?: boolean;
  onDeleteNote?: () => void;
  onOpenNewNote?: () => void;
}

export const useNotesModal = (params: UseNotesModalParams) => {
  const modalContext = useNotesModalContext();
  const notesMenu = useNotesMenu(params);

  return {
    ...modalContext,
    ...notesMenu
  };
};
